<template>
  <div :class="classes()">
    <Container>
      <div :class="`${el}__inner`">
        <Copy
          v-if="headline"
          element="div"
          color="primaryBlue"
          :staticClass="`${el}__headline`"
          bold
          centered
        >
          {{ headline }}
        </Copy>

        <div :class="`${el}__progessWrapper`">
          <template v-if="currentStep <= steps">
            <div :class="`${el}__progess`">
              <div
                :class="`${el}__progessBar`"
                :style="`width: ${(100 / (steps - 1)) * (currentStep - 1)}%`"
              />
            </div>
            <ul :class="`${el}__list`">
              <li
                v-for="i in steps"
                :key="`statusbar-item-${i}`"
                :class="{
                  [`${el}__listItem`]: true,
                  [`${el}__listItem--done`]: i < currentStep,
                  [`${el}__listItem--active`]: i === currentStep,
                }"
              >
                <span v-if="i < currentStep" :class="`${el}__listItemNumber`">
                  <Icon v-if="i < currentStep" name="check-line" size="s" color="neutral0" />
                </span>
                <span v-else :class="`${el}__listItemNumber`">{{ i }}</span>
              </li>
            </ul>
          </template>
          <div v-else :class="`${el}__done`">
            <div :class="`${el}__iconCheck`">
              <Icon name="check-fill" size="s" color="neutral0" />
            </div>
            <Copy color="supportSuccess" element="span" size="s" bold>
              {{ statusText }}
            </Copy>
          </div>
        </div>
      </div>
    </Container>
  </div>
</template>

<script>
import Container from '@/objects/Container';
import Copy from '@/objects/Copy';
import Icon from '@/objects/Icon';

export default {
  name: 'Statusbar',
  components: {
    Container,
    Copy,
    Icon,
  },
  props: {
    headline: String,
    currentStep: {
      type: Number,
      required: true,
    },
    steps: {
      type: Number,
      required: true,
    },
    fixed: Boolean,
    sticky: Boolean,

    statusText: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      el: 'c-statusbar',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--fixed`]: this.fixed,
          [`${el}--sticky`]: this.sticky,
        };
      },
    };
  },
};
</script>
